export default {
    login_register: 'Bejelentkezés/Regisztráció',
    booking_confirmation_title: 'Foglalás visszaigazolása',
    booking_confirmation_body: 'Köszönjük a foglalását. Az alábbiakban találja a visszaigazolás részleteit.',
    insurance_requirements_modal_disclaimer: `A foglalás elküldésével megerősítem, hogy: az elmúlt 5 évben nem volt elítélésem vagy közlekedési szabálysértésem. Nem utasítottak el biztosítási ajánlatot, nem mondtak fel biztosítást, nem utasítottak el megújítást, és nem írtak elő magasabb díjat vagy különleges feltételeket egyetlen gépjármű-biztosító sem. Nem tiltottak el a vezetéstől. Nincs folyamatban büntetőeljárás vagy rendőrségi vizsgálat ellenem. Az elmúlt 5 évben nem ítéltek el lopás, csalás vagy tisztességtelenség miatt. Nem szenvedek látás- vagy halláskárosodásban (amelyet szemüveg vagy hallókészülék nem korrigál), szívbetegségben, cukorbetegségben, rohamokban vagy bármilyen testi vagy szellemi fogyatékosságban. Az elmúlt 5 évben nem volt balesetem. Kattintson ide: {0}, ha nem felel meg ezeknek a feltételeknek.`,
    insurance_requirements_here: 'itt',
    insurance_requirements: 'Elolvastam és megértettem a(z) {0} feltételeit',
    ir: 'Biztosítási feltételek',
    location: 'Helyszín',
    pickup_location: 'Átvételi hely',
    dropoff_location: 'Leadási hely',
    vehicle: 'Jármű',
    pickup_and_dropoff: 'Átvétel és leadás (helyi idő szerint)',
    view_voucher: 'Voucher megtekintése',
    identity_verification_body: 'A jármű átvétele előtt igazolnia kell személyazonosságát',
    identity_verification_title: 'Személyazonosság igazolása',
    search_again: 'Új keresés',
    refrigerated: 'hűtött',
    aircon_lower: 'klíma',
    aircon: 'Klímaberendezés',
    refrigeration: 'Hűtött',
    not_available: 'A Drive & Go jelenleg csak az alábbi országokból származó személyazonosító és jogosítvány dokumentumokkal rendelkező személyek számára elérhető.',
    check_if_included: 'Ellenőrizze, hogy az Ön országa szerepel-e a listán.',
    included_in_booking: 'Benne van ebben a foglalásban',
    cdw_with_excess: 'CDW önrésszel',
    theft_protection: 'Lopásvédelem önrésszel',
    risk_reduction: 'Kockázatcsökkentés',
    free_extras: 'Ehhez a foglaláshoz két ingyenes extra jár.<br />',
    continue: 'Folytatás',
    luggage_large_short_label: 'N',
    luggage_medium_short_label: 'K',
    luggage_small_short_label: 'K',
    luggage_large_long_label: 'nagy',
    luggage_medium_long_label: 'közepes',
    luggage_small_long_label: 'kicsi',
    fuel_unspecified_label: 'nincs megadva',
    transmission_manual_label: 'Manuális',
    transmission_automatic_label: 'Automata',
    make_a_booking: 'Foglalás',
    pickup_date: 'Átvétel dátuma',
    dropoff_date: 'Leadás dátuma',
    driver_age: 'Vezető életkora 30-65 év között',
    enter_driver_age: 'Kérjük, adja meg a vezető életkorát',
    promo_code: 'Promóciós kód',
    search: 'Keresés',
    dropoff_date_cannot_be_before_pickup_date: 'A leadás dátuma nem lehet korábbi, mint az átvétel dátuma',
    pickup_date_cannot_be_in_the_past: 'Az átvétel dátuma nem lehet múltbeli',
    pickup_time_cannot_be_in_the_past: 'Az átvétel időpontja nem lehet múltbeli',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'A leadás időpontjának későbbinek kell lennie, mint az átvétel időpontja, ha ugyanazon a napon történik',
    vehicle_filters: 'Járműszűrők',
    reset: 'Visszaállítás',
    transmission: 'Váltó',
    all: 'Összes',
    manual: 'Manuális',
    auto: 'Automata',
    passengers: 'Utasok',
    vehicle_type: 'Jármű típusa',
    filter: 'Szűrés',
    vehicle_search: 'Járműkeresés',
    edit: 'Szerkesztés',
    no_results: 'Nincs találat a szűrési feltételeknek megfelelően.',
    small_cars: 'Kisautók',
    medium_cars: 'Közepes autók',
    large_cars: 'Nagy autók',
    estate_cars: 'Kombi autók',
    suvs: 'SUV-k',
    mpvs: 'Egyterűek',
    vans: 'Furgonok',
    camper_vans: 'Lakóautók',
    premium: 'Prémium',
    unspecified: 'nincs megadva',
    large: 'nagy',
    medium: 'közepes',
    small: 'kicsi',
    automatic: 'automata',
    you_have_been_refunded: 'A visszatérítés megtörtént.',
    please_customer_service: 'Foglaláshoz kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal.',
    contact_customer_service: 'Kapcsolatfelvétel ügyfélszolgálattal',
    booking_failed: 'A foglalást most nem sikerült feldolgozni.',
    summary: 'Összegzés',
    reforestation_and_protection: 'Támogassa az esőerdők újraerdősítését és védelmét Costa Ricában',
    cost_of_rental: 'Bérleti díj',
    to_pay_now: 'Fizetendő most',
    greenheart_donation: 'Green Heart adomány',
    total_cost: 'A bérlés teljes költsége',
    tc_agreement: 'Elolvastam és megértettem a(z) {0} feltételeit.',
    tc: 'ÁSZF',
    receive_offers: 'Szeretnék különleges ajánlatokat kapni e-mailben.',
    donate: 'Igen, szeretnék {amount} összeget adományozni',
    pay_now: 'Fizessen most: {amount}',
    driver_details: 'Vezető adatai',
    complete_driver_details: 'Kérjük, töltse ki a vezető adatait.',
    are_you_the_driver: 'Ön a vezető?',
    have_an_account: 'Van már fiókja?',
    login: 'Bejelentkezés',
    or: 'vagy',
    first_name: 'Vezető keresztneve',
    last_name: 'Vezető vezetékneve',
    email: 'E-mail cím',
    phone_number: 'Mobiltelefonszám',
    unable_to_save_driver_information: 'A vezető adatait nem sikerült menteni. Kérjük, próbálja újra.',
    pay_online_now: 'Fizetés most',
    day: 'Nap',
    choose_location: 'Válasszon helyszínt',
    location_not_found: 'Sajnáljuk, a kért helyszínt nem találtuk.',
    add: 'Hozzáadás',
    remove: 'Eltávolítás',
    free_extra: 'Ingyenes extra',
    free: 'INGYENES!',
    fast_track_notice: 'Ehhez a szolgáltatáshoz dokumentum-eredet korlátozások vonatkoznak. Csak az alábbi országokból származó dokumentumokkal rendelkező személyek számára elérhető.',
    complete_booking: 'Foglalás befejezése',
    choose_card: 'Kérjük, válasszon kártyát vagy adjon hozzá újat.',
    add_billing_details: 'Kérjük, adja meg a számlázási adatokat.',
    card_number: 'Kártyaszám',
    card_holder_name: 'Kártyabirtokos neve',
    card_exp: 'HH / ÉÉ',
    card_cvc: 'CVC',
    save_card: 'Kártya mentése?',
    amount_charged: 'A kártyáját megterheljük',
    payment_confirmation: 'Foglalás megerősítése és fizetés',
    payment_methods: 'elérhető fizetési módok',
    use_saved_card: 'x mentett kártya használata',
    use_different_card: '+ másik kártya használata',
    book_now: 'Foglaljon most',
    minimum_age: 'Csak {age} év felettieknek',
    excess_liability: 'Önrész',
    security_deposit: 'Kaució',
    fuel_policy: 'Üzemanyag szabályzat',
    like_for_like: 'Ugyanannyival vissza',
    full_to_full: 'Tele tankkal - tele tankkal',
    miles_per_rental: '{mileage} ingyenes mérföld bérlésenként',
    km_per_rental: '{mileage} ingyenes km bérlésenként',
    unlimited_mileage: 'Korlátlan futásteljesítmény',
    unlimited_mileage_km: 'Korlátlan km',
    non_amendable: 'Nem módosítható',
    non_refundable: 'Nem visszatéríthető',
    free_cancellation_until: 'Ingyenes lemondás eddig:',
    cancellation_in_line_with: 'Lemondás a következő szerint:',
    tcs: 'ÁSZF',
    free_extras_on_collection: 'Két ingyenes extra átvételkor',
    glass_and_tyres_covered: 'Üveg és gumiabroncs fedezve',
    number_of_passengers: 'Utasok száma',
    number_of_bags: 'Csomagok száma',
    fuel_type: 'Üzemanyag típusa',
    co2: 'CO2',
    book_type: '{type} foglalása',
    processing: 'Feldolgozás',
    actual_price: 'Tényleges ár',
    tooltip: 'A(z) {currencyCode} ár tájékoztató jellegű, az árfolyamon alapul, a(z) {currency} ár a mérvadó.',
    deposit: 'Kaució',
    pay_online: 'Fizetés most',
    pay_online_without_extras: 'Bérleti díj',
    extras_on_arrival: 'Extrák átvételkor',
    insurance_on_arrival: 'Kockázatcsökkentés - fizetés átvételkor',
    insurance_online: 'Kockázatcsökkentés - fizetés most',
    extras_online: 'Extrák - fizetés most',
    green_heart_donation: 'Green Heart adomány',
    why_use_drive_and_go: 'Miért válassza a Drive & Go-t?',
    straight_to_car: 'Közvetlenül az autóhoz',
    no_queues: 'Nincs sorban állás',
    self_checkout: 'Önkiszolgáló átvétel',
    cant_lose_key: 'A kulcs nem veszíthető el',
    online_id_check: 'Online azonosítás',
    phone_as_key: 'Telefon mint kulcs',
    premiumplus_benefits_includes: 'A Premium Plus+ előnyök is benne vannak',
    book_drive_go: 'Drive & Go foglalás',
    distance_allowance: 'Megengedett távolság',
    duration: 'Időtartam',
    view_more_bookings: 'További foglalások megtekintése',
    to_pay_on_arrival: 'Fizetendő átvételkor',
    pay_on_arrival: 'Fizetés átvételkor',
    unlimited: 'Korlátlan',
    return_date: 'Visszaadás dátuma',
    postcode: 'Irányítószám',
    country: 'Ország',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'A Drive & Go jelenleg csak az alábbi országokból származó személyazonosító és jogosítvány dokumentumokkal rendelkező személyek számára elérhető:',
        drive_and_go_today: 'Drive & Go foglalás mára!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Miért válassza a Drive & Go-t?',
        straight_to_car: 'Közvetlenül az autóhoz',
        no_queues: 'Nincs sorban állás',
        self_checkout: 'Önkiszolgáló átvétel',
        cannot_lose_the_key: 'A kulcs nem veszíthető el',
        online_id_check: 'Online azonosítás',
        phone_as_a_key: 'Telefon mint kulcs',
        premium_plus_benefits_also_included: 'A Premium Plus+ előnyök is benne vannak',
        book_drive_and_go: 'Drive & Go foglalás',
    },
    car_and_camp: {
        tent_and_equipment: 'Sátor és felszerelés',
        quick_and_easy: 'Gyorsan és egyszerűen felállítható',
        travel_freedom: 'Utazási szabadság',
        affordable_campervan_alternative: 'Megfizethető alternatíva a lakóautóhoz',
        lightweight_and_compact: 'Könnyű és kompakt',
        fully_insured: 'Teljes körű biztosítással',
    },
    my_bookings: 'Saját foglalás',
    no_bookings: 'Nincs foglalás',
    my_profile: 'Profilom',
    no_bookings_to_display: 'Nincs megjeleníthető foglalás.',
    search_great_car_rental_deals: 'Keressen nagyszerű autóbérlési ajánlatokat a következő utazásához.',
    odometer_at_collection: 'Kilométeróra átvételkor',
    fuel_at_collection: 'Üzemanyag átvételkor',
    start_check_in: 'Bejelentkezés indítása',
    start_collection: 'Átvétel indítása',
    recent_bookings: 'Legutóbbi foglalás',
    damage: {
        updated_damage_report_submitted: 'Frissített kárjelentés lett beküldve. Ügyfélszolgálatunk szükség esetén felveszi Önnel a kapcsolatot.',
        add_additional_damage: 'További kár hozzáadása',
        you_may_report_additional_damage_up_to: 'További kárt jelenthet be a jármű leadását követő 24 órán belül',
        specify_damage: 'Kár megadása',
        please_choose_the_area_and_type_of_damage: 'Kérjük, válassza ki a kár helyét és típusát',
        type_of_damage: 'Kár típusa',
        is_this_more_than_5_cm: 'Ez több mint 5 cm?',
        please_take_or_select_a_photo: 'Kérjük, készítsen vagy válasszon egy fényképet',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Kérjük, készítsen olyan fényképet, amelyen a kár jól látható',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Szükség esetén további képet is hozzáadhat, válassza ki az ikont',
        save_image: 'Kép mentése',
        save_images: 'Képek mentése',
        damage_saved_successfully: 'A kár sikeresen mentve',
        add_photo: 'Kép hozzáadása',
    },
    checkout: {
        start_collection: 'Átvétel indítása',
        collect_vehicle: 'Jármű átvétele',
        we_will_let_you_know_the_details: 'Értesítjük a helyszínről és a részletekről, hogy megtalálja a bérelt járművet.',
        inspect: 'Átvizsgálás',
        we_will_ask_for_four_photos_from_each_corner: 'Négy fényképet kérünk a jármű minden sarkából, valamint minden új, még nem jelentett kárról.',
        fuel_and_milage: 'Üzemanyag & futásteljesítmény',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Megerősíti a kilométeróra és az üzemanyag állását a bérlés kezdetén.',
        sign: 'Aláírás',
        sign_the_rental_agreement: 'Bérleti szerződés aláírása.',
        away_you_go: 'Jó utat!',
        you_are_free_to_take_to_the_road: 'Szabad az út!',
        collect_your_vehicle: 'Vegye át a járművét',
        get_directions: 'Útvonalterv',
        hide_directions: 'Útvonal elrejtése',
        local_time: 'helyi idő',
        tel: 'Tel',
        getting_to_the_location: 'Helyszín megközelítése',
        get_vehicle_details: 'Jármű adatai',
        view_map: 'Térkép megtekintése',
        unlock_vehicle_and_continue: 'Jármű nyitása & folytatás',
        unable_to_connect_to_vehicle: 'Nem sikerült csatlakozni a járműhöz',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Nem sikerült csatlakozni a járműhöz – ellenőrizze, hogy a megfelelő jármű mellett áll, majd próbálja újra.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nem találtuk a jármű foglalását. Próbálja újra később.',
        odometer_and_fuel: 'Kilométeróra & üzemanyag',
        odometer: 'Kilométeróra',
        please_confirm_the_odometer_and_fuel_readings: 'Ha lehetséges, erősítse meg a kilométeróra és az üzemanyag állását.',
        the_odometer_field_is_required: 'A kilométeróra mező kitöltése kötelező',
        and_must_be_greater_than_the_checkout_odometer: 'és nagyobbnak kell lennie, mint az átvételkor mért érték',
        confirm: 'Megerősítés',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Kérjük, készítsen képet a jármű minden sarkáról',
        pre_existing_damage: 'Korábbi kár',
        no_pre_existing_damage: 'Nincs korábbi kár.',
        new_damage: 'Új kár',
        add_additional_damage: 'további kár hozzáadása',
        no_new_damage_to_report: 'Nincs új kár jelenteni',
        checkout_complete: 'Átvétel kész',
        start_rental: 'Bérlés indítása',
        congratulations_name_it_is_time_to_take_to_the_road: 'Gratulálunk {customer_name}, indulhat az út!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Nem tudjuk befejezni a jármű átvételét.',
        please_do_the_following: 'Kérjük, tegye a következőket',
        remove_all_belonging_and_lock_the_vehicle: 'Távolítson el minden holmit, és zárja le a járművet.',
        lock_vehicle: 'Jármű lezárása',
        once_you_have_contacted_customer_services: 'Miután kapcsolatba lépett az ügyfélszolgálattal',
        vehicle_location: 'Jármű helye',
        collect_your: 'Vegye át a(z)',
        from: 'Innen',
        key_in_glove_box: 'a kulcs a kesztyűtartóban található',

        keyholder: {
            not_detected: 'A kulcsot nem érzékeli a tartó',
            not_detected_please_try_again: 'Kérjük, helyezze a kulcsot a tartóba, majd próbálja újra.',

            not_installed: 'Kulcstartó nincs telepítve',
            not_installed_please_contact_customer_service: 'A kulcstartó nincs telepítve, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.',
        },
        keyring: {
            look_up_failed: 'Kulcstartó keresése sikertelen',
            look_up_failed_please_contact_customer_service: 'A kulcstartó keresése sikertelen, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.',
        },
        key: {
            invalid: 'A kulcs érvénytelen',
            invalid_please_contact_customer_service: 'A kulcs érvénytelen, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.',

            expired: 'A kulcs lejárt',
            expired__please_contact_customer_service: 'A kulcs lejárt, kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.',
        },
    },
    checkin: {
        start_check_in: 'Bejelentkezés indítása',
        vehicle_location: 'Jármű helye',
        tell_us_where_you_have_parked: 'Kérjük, mondja el, hol parkolta le a járművet.',
        fuel_and_milage: 'Üzemanyag & futásteljesítmény',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Megerősíti a kilométeróra és az üzemanyag állását a bérlés végén.',
        inspect: 'Átvizsgálás',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Négy fényképet kérünk a jármű minden sarkából, valamint minden új, a bérlés során keletkezett kárról.',
        lock: 'Lezárás',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Ellenőrizze, hogy nem maradt-e holmi, majd zárja le a járművet.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Kérjük, mondja el, hol parkolta le a járművet',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'A jármű lezárása után nem lehet újra kinyitni.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, kérjük, ellenőrizze, hogy nem maradt-e holmi, zárja le a járművet, és ha szükséges, adja vissza a fizikai kulcsot a tartóba.',
        lock_vehicle: 'Jármű lezárása',
        complete_check_in: 'Bejelentkezés befejezése',
        inspection: 'Átvizsgálás',
        complete_vehicle_check_in: 'Jármű bejelentkezés befejezése',
        we_are_unable_to_complete_your_vehicle_check_in: 'Nem tudjuk befejezni a jármű bejelentkezését.',
        please_contact_customer_services: 'Kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal',
        once_you_have_contacted_customer_services: 'Miután kapcsolatba lépett az ügyfélszolgálattal',
        please_amend_odometer_to_be_greater_than: 'Kérjük, módosítsa a kilométerórát, hogy nagyobb legyen, mint {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Bérleti szerződés',
        agreement_between: 'Szerződés a következők között',
        and: 'és',
        sign_rental_agreement: 'Bérleti szerződés aláírása',
        i_have_read_and_understood_the_terms_and_conditions: 'Elolvastam és megértettem a feltételeket, és elfogadom a jármű állapotát',
    },
    additional_options: 'További opciók',
    booking_details: 'Foglalás részletei',
    price_for_x_days: 'Ár {qty_of_days} napra | Ár {qty_of_days} napra',
    cancelled: 'Lemondva',
    upcoming: 'Közelgő',
    active: 'Aktív',
    full_insurance_no_deposit: 'Teljes biztosítás & nincs szükség kaucióra',
    excess: '{amount} önrész',
    deposit: '{amount} kaució',
    included_daily_distance: '{distance} {unit} naponta',
    miles: 'mérföld',
    kilometers: 'kilométer',
    collection_details_title: 'Átvétel részletei',
    collection_details_not_found: 'Ehhez a helyszínhez nincs átvételi információ megadva',
    free_cancellation: 'Ingyenes lemondás',
    no_deposit: 'Nincs kaució',
    benefit_from: 'Élvezze',
    for_only_per_day: 'Csak {price} naponta',
    upgrade_mee: 'UpgradeMee',
};
